


export class MainForumTopicView {
    constructor() {
        this.template = document.getElementById('topic-template');
        this.container = document.getElementById('topics-container');
        this.container3 = document.getElementById('topics-container-3');
    }

    render(state) { 

        if (!(state && Object.keys(state).length > 0)) { return;}

        state.data.forEach((topic, index) => {

            if (index < 5) { 
                const li = this.getNextEmptyElement(this.container);
                if (li instanceof Element) { 
                    
                    const t = this.renderPartial(topic);
                    li.replaceWith(t);
                }
            }

            const li3 = this.getNextEmptyElement(this.container3);
            if (li3 instanceof Element) {
                
                const t = this.renderPartial(topic);
                li3.replaceWith(t);
            }
        });
    }
    
    renderPartial(topic) {

        const clone = this.template.content.cloneNode(true);

        clone.querySelector('article.topic').dataset.id = topic.id;
        
        const img = clone.querySelector('img');
        if (img) { img.src = topic.avatarUrl;}

        clone.querySelector('.username').textContent = topic.username;
        if (topic.profileUrl) { clone.querySelector('.user').href = topic.profileUrl;}

        clone.querySelector('.date').textContent = topic.date;
        clone.querySelector('.title-link').textContent = topic.title;
        clone.querySelector('.title-link').href = topic.url;
        clone.querySelector('.views-count').textContent = topic.views;
        clone.querySelector('.comments-count').textContent = topic.comments;
        clone.querySelector('.likes-count').textContent = topic.likes;
        if (topic.hasOwnProperty('isActiveLike') && topic.isActiveLike) { 
            clone.querySelector('.ci.like').classList.add('toggled');
        }
        clone.querySelector('.comments-link').href = topic.url + '#comments';

        return clone;
    }

    getNextEmptyElement(container) {
        return Array.from(container.querySelectorAll('.li')).find(el => {
            const title = el.querySelector('.title');
            return !title || title.textContent.trim() === '';
        });
    }
}